const stickyHeader = () => {
	const header = document.querySelector( '.top-bar' );
	const headerHeight = header.getBoundingClientRect().height;
	const logoMain = document.querySelector( '.site-logo-main' );
	const logoScroll = document.querySelector( '.site-logo-scroll' );
	if ( window.scrollY > headerHeight ) {
		// console.log( 'yes' );
		header.classList.add( 'bg-black' );
		header.classList.remove( 'bg-white' );
		logoMain.classList.add( 'o-0' );
		logoMain.classList.remove( 'o-100' );
		logoScroll.classList.add( 'o-100' );
		logoScroll.classList.remove( 'o-0' );
	} else {
		// console.log( 'no' );
		header.classList.add( 'bg-white' );
		header.classList.remove( 'bg-black' );
		logoMain.classList.add( 'o-100' );
		logoMain.classList.remove( 'o-0' );
		logoScroll.classList.add( 'o-0' );
		logoScroll.classList.remove( 'o-100' );
	}
}
document.addEventListener( 'scroll', stickyHeader );
document.addEventListener( 'DOMContentLoaded', stickyHeader );
window.addEventListener( 'resize', stickyHeader );
